<template>
  <section class="form-surface">
    <div class="form-panel">
      <h1>Confirm email change</h1>
      <div class="workspace-alert">{{ message }}</div>
      <RouterLink class="app-link" to="/settings/profile">Back to settings</RouterLink>
    </div>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import { CommandsService } from '../api/generated';
import { getErrorMessage } from '../stores/session';

const route = useRoute();
const message = ref('Confirming email change.');

onMounted(async () => {
  const token = typeof route.query.token === 'string' ? route.query.token : '';
  if (!token) {
    message.value = 'Email change token is missing.';
    return;
  }

  try {
    await CommandsService.commandConfirmEmailChangeCommand({ requestBody: { token } });
    message.value = 'Email changed.';
  } catch (error) {
    message.value = getErrorMessage(error, 'Unable to confirm email change.');
  }
});
</script>
